export default "__VITE_ASSET__996a4c84__"